import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutAndSustainabilityContentForm from "./AboutAndSustainabilityContentForm";
import { useGetAboutAndSustainabilityContentDetailsQuery } from "../../../../store/services/AboutAndSustainabilityContentService";

function AboutAndSustainabilityContent() {
  const { data: pageDetails, error, isLoading } = useGetAboutAndSustainabilityContentDetailsQuery();

  console.log("details =======>", pageDetails?.data);

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              About Us & Sustainability Content
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!isLoading && (
            <AboutAndSustainabilityContentForm data={pageDetails?.data} />
          )}
        </Row>
      </Container>
    </section>
  );
}

export default AboutAndSustainabilityContent;
